// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__dYq40","resultCard":"styles_resultCard__4FYUG unselectable_unselectable__CvM2m","admin":"styles_admin__l2+RL"};